module.exports = __webpack_public_path__ + "static/media/mobile_mockup_4.d27593e1.png";